const API_URL = "https://api.kanaa.app/api/";

export { API_URL };
